import React, { useEffect } from "react";
import "./ServiceContactModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faTelegramPlane } from "@fortawesome/free-brands-svg-icons";
import { useLocalContext } from "../../../context/LocalContext";

const serviceOptions = [
  "Microsoft 365 Copilot",
  "Microsoft 365",
  "Microsoft Azure",
  "Dynamics 365",
  "Managed Print Services",
  "Cloud Print Management",
  "Secure & Compliant Printing",
  "Printer Fleet Optimization",
  "Proactive Support & Maintenance",
  "Document Workflow Automation",
  "Web & Product Development",
"Custom Web Application Development",
"SaaS & MVP Development",
  "Antivirus & Endpoint Security",   

];

const ServiceContactModal = ({ isOpen, onClose, defaultService }) => {
  const { webinfo = {} } = useLocalContext();

  // ---- Contact details from webinfo ----
  const phone = webinfo.phone || "+91 80000 00000";
  const whatsapp = webinfo.whatsapp || phone; // fallback to phone
  const telegram = webinfo.telegram || "yourtelegramhandle";

  const phoneHref = webinfo.phone_link || `tel:${phone.replace(/\s+/g, "")}`;
  const whatsappHref =
    webinfo.whatsapp_link ||
    `https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`;
  const telegramHref =
    webinfo.telegram_link ||
    (telegram.startsWith("http")
      ? telegram
      : `https://t.me/${telegram.replace("@", "")}`);

  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Hook this into your form handler / API
    // const data = Object.fromEntries(new FormData(e.target).entries());
    onClose?.();
  };

  return (
    <div className="scm-backdrop" onClick={onClose}>
      <div
        className="scm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="service-modal-title"
        onClick={(e) => e.stopPropagation()} // prevent close on inner click
      >
        <button className="scm-close" type="button" onClick={onClose}>
          ✕
        </button>

        <header className="scm-header">
          <h2 id="service-modal-title">Talk to us about your project</h2>
          <p>
            Share a few details and we’ll get back to you with next steps,
            timelines and pricing options.
          </p>
        </header>

        <form className="scm-form" onSubmit={handleSubmit}>
          <div className="scm-field">
            <label htmlFor="scm-name">Name</label>
            <input
              id="scm-name"
              name="name"
              type="text"
              placeholder="Your name"
              required
            />
          </div>

          <div className="scm-row">
            <div className="scm-field">
              <label htmlFor="scm-email">Email</label>
              <input
                id="scm-email"
                name="email"
                type="email"
                placeholder="you@company.com"
                required
              />
            </div>
            <div className="scm-field">
              <label htmlFor="scm-phone">Phone</label>
              <input
                id="scm-phone"
                name="phone"
                type="tel"
                placeholder={phone}
              />
            </div>
          </div>

          <div className="scm-field">
            <label htmlFor="scm-service">Service you’re interested in</label>
            <select
              id="scm-service"
              name="service"
              defaultValue={defaultService || ""}
              required
            >
              <option value="" disabled>
                Select a service
              </option>
              {serviceOptions.map((service) => (
                <option key={service} value={service}>
                  {service}
                </option>
              ))}
            </select>
          </div>

          <div className="scm-field">
            <label htmlFor="scm-message">Project details</label>
            <textarea
              id="scm-message"
              name="message"
              rows="4"
              placeholder="Tell us about your requirements, timeline and current setup…"
            />
          </div>

          <button type="submit" className="scm-submit">
            Send enquiry
          </button>
        </form>

        <div className="scm-contact-strip">
          <p>Or reach us directly:</p>
          <div className="scm-contact-actions">
            <a href={phoneHref} className="scm-contact-btn">
              <FontAwesomeIcon icon={faPhone} />
              <span>{phone}</span>
            </a>
            <a
              href={whatsappHref}
              target="_blank"
              rel="noreferrer"
              className="scm-contact-btn"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>Chat on WhatsApp</span>
            </a>
            <a
              href={telegramHref}
              target="_blank"
              rel="noreferrer"
              className="scm-contact-btn"
            >
              <FontAwesomeIcon icon={faTelegramPlane} />
              <span>Message on Telegram</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceContactModal;
